import { useEffect, useState } from "react";
import Overlay from "../../Componentes/Overlay";
import Modal from "../../Componentes/Utils/Modal";
import Tabela from "../../Componentes/Utils/Tabela";
import { useModal } from "../../contexts/ModalContext";
import SmallLoading from "../../Componentes/Utils/SmallLoading";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { formatValorMoney } from '../../Funcoes/FormatValorMoney';
import useApi from "../../hooks/useApi";

const TableCell = styled.td`
    color: #000;
    text-align: ${(props) => {
        if (props.align === "left") return "left !important";
        if (props.align === "center") return "center !important";
        if (props.align === "right") return "right !important";
        return "left !important";
    }};
`

const ModalBeneficios = () => {

    const { matricula } = useParams();

    const { closeModal } = useModal();

    const api = useApi();

    const [loading, setLoading] = useState(true);
    const [beneficios, setBeneficios] = useState([]);

    const fetchData = async () => {

        setLoading(true);

        try {

            const { data } = await api.get(`/Painel/API/Colaborador/GetBenefits/index.php?matricula=${matricula}`)
            setBeneficios(data);

        } catch (e) {

            console.log(e);

        } finally {

            setLoading(false);

        }

    }

    useEffect(() => {

        fetchData();

    }, [])

    return (
        <>
            <Overlay state={true} >
                <Modal size="md" header={true} close={closeModal} >
                    <Tabela>
                        <thead>
                            <tr>
                                <th>BENEFÍCIO</th>
                                <th>VALOR</th>
                            </tr>
                        </thead>
                        <tbody>
                            {beneficios.map(obj => (
                                <tr key={obj.BENEFICIO} >
                                    <TableCell align="left" >{obj.BENEFICIO}</TableCell>
                                    <TableCell align="right" >{formatValorMoney(obj.VALOR)}</TableCell>
                                </tr>
                            ))}
                        </tbody>
                    </Tabela>
                </Modal>
            </Overlay>
            {loading && (
                <Overlay state={true} >
                    <Modal size="sm" >
                        <SmallLoading />
                    </Modal>
                </Overlay>
            )}
        </>
    )
}

export default ModalBeneficios;